import PurposeIcon from './component.jsx'
export default PurposeIcon
